import { RequestError } from '../Models/RequestError';

type ReportSource = { report: any; parameters: any; } | null;
type ReportSources = { firstReportSource: ReportSource; secondReportSource: ReportSource; };

export function debounce(fn: Function, ms = 300) {
    let timeoutId: ReturnType<typeof setTimeout>;

    return function(this: any, ...args: any[]) {
        clearTimeout(timeoutId);
        // eslint-disable-next-line no-invalid-this
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
}

export function throttle(fn: Function, ms: number) {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function(that: any, ...args: any[]) {
        if (!timeout) {
            timeout = setTimeout(function() {
                fn.apply(that, args);
                timeout = null;
            }, ms);
        }
    };
}

export function isExceptionOfType(error: RequestError, errorType: string): boolean {
    if (error.responseJSON) {
        return error.responseJSON.exceptionType === errorType;
    }

    return false;
}

export function isInvalidClientException(error: RequestError): boolean {
    return isExceptionOfType(error, 'Telerik.Reporting.Services.Engine.InvalidClientException');
}

export function isInvalidParameterException(error: RequestError): boolean {
    return isExceptionOfType(error, 'Telerik.Reporting.Services.Engine.InvalidParameterException');
}

export function isInternalServerError(error: string | undefined): boolean {
    if (error) {
        return error.split(' ').join('').toLowerCase() === 'internalservererror';
    }

    return false;
}

export function stringFormat(str: string, ...args: any[]): string {
    return str.replace(/{(\d+)}/g, (match, index) => args[index] || '');
}

export function reportSourcesAreEqual(sources: ReportSources) {
    const firstReportSource = sources.firstReportSource;
    const secondReportSource = sources.secondReportSource;
    if (firstReportSource && secondReportSource && firstReportSource.report === secondReportSource.report) {

        let params1String = '';
        if (firstReportSource.parameters) {
            params1String = JSON.stringify(firstReportSource.parameters);
        }

        let params2String = '';
        if (secondReportSource.parameters) {
            params2String = JSON.stringify(secondReportSource.parameters);
        }

        return params1String === params2String;
    }

    return false;
}

// Standard Web API each implementation
export function each(obj, callback) {

    let length;
    let i;

    if (isArray(obj)) {
        length = obj.length;
        for (i = 0; i < length; i++) {
            if (callback.call(obj[i], i, obj[i]) === false) {
                break;
            }
        }
    } else {
        for (i in obj) {
            if (callback.call(obj[i], i, obj[i]) === false) {
                break;
            }
        }
    }

    return obj;
}

export function isArray(obj) {

    if (Array.isArray(obj))
        return true;

    // eslint-disable-next-line no-implicit-coercion
    const length = !!obj && 'length' in obj && obj.length;
    if (typeof length === 'number') {
        return true;
    }

    return false;
}

export function tryParseInt(value) {
    // eslint-disable-next-line no-useless-escape
    if (/^(\-|\+)?([0-9]+)$/.test(value)) {
        return Number(value);
    }

    return NaN;
}

export function tryParseFloat(value) {
    // eslint-disable-next-line no-useless-escape
    if (/^(\-|\+)?([0-9]+(\.[0-9]+)?)$/.test(value)) {
        return Number(value);
    }

    return NaN;
}

export function parseToLocalDate(date) {
    if (date instanceof Date)
        return date;


    // eslint-disable-next-line no-useless-escape
    var isUtc = /Z|[\+\-]\d\d:?\d\d/i.test(date);

    if (!isUtc) {
        // eslint-disable-next-line no-param-reassign
        date += 'Z';
    }

    return new Date(date);
}
